import { TEST_SIGNING } from './signing-test-key';

export const environment = {
  production: false,
  endPoint: 'https://apitest.lycheeapp.org/rest/lychee-v2/',
  serverRoot: 'https://store.lycheeapp.org/',
  googleMapsKey: 'AIzaSyDoz5SfbKJV_D4nflKhueqh4hw_IKH4d3I',
  // LYCHEE-SIGN-V1 build-time signing key (lychee-store) — test backend.
  signing: TEST_SIGNING,
};
